// extracted by mini-css-extract-plugin
export default {"notif-menu":"bellAlerts_notif-menu__WTQZF","notification-counter":"bellAlerts_notification-counter__DZ0NM","redDot":"bellAlerts_redDot__cDTu9"};